export default __webpack_public_path__ + "static/media/whatsapp.9e70e435.svg";